export default __webpack_public_path__ + "static/media/navdishaBannernew.ffe3eba0.svg";